/**
 * Image Text Block
 */
export default class FAQPanel {
    initFAQ() {
        const toggles = document.querySelectorAll('.js-accordion-toggle');
    
        toggles.forEach((accordionToggle) => {
            accordionToggle.addEventListener('click', (e) => {   
                if (accordionToggle.parentNode.classList.contains('active') === true) {
                    toggles.forEach((accordionToggle2) => {
                        accordionToggle2.parentNode.classList.remove('active');
                    });
                } else {
                    toggles.forEach((accordionToggle2) => {
                        accordionToggle2.parentNode.classList.remove('active');
                    });
    
                    accordionToggle.parentNode.classList.add('active');
                }
            });
        });
    }
    
    init() {
        this.initFAQ();
    }
}

